import { SxProps, Theme } from '@mui/material';

export const pageBoxSx: SxProps<Theme> = {
  pt: 4,
  pr: 4,
  pb: 4,
  pl: '24px',
  flex: 1,
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: '#F9FAFB',
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 56px)'
};

export const pageTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 700,
  fontStyle: 'normal',
  fontSize: '20px',
  lineHeight: '30px',
  letterSpacing: '-0.45px',
};

export const headerWrapperSx: SxProps<Theme> = { pt: 2 };
export const breadcrumbRowSx: SxProps<Theme> = { mb: 1, display: 'flex', alignItems: 'center', gap: 1 };
export const breadcrumbButtonSx: SxProps<Theme> = { textTransform: 'none', p: 0, minWidth: 0, color: '#6B7280', fontSize: '13px' };
export const breadcrumbSeparatorSx: SxProps<Theme> = { fontSize: '13px', color: '#6B7280' };

// Top header row containing the page/section title on the left and
// a status label (Active / Inactive) on the right when editing an existing node.
export const headerTopRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  mt: 1,
};

export const statusChipBaseSx: SxProps<Theme> = {
  borderRadius: '10px',
  px: 1.5,
  py: 0.5,
  fontSize: '13px',
  lineHeight: '19.5px',
  fontWeight: 500,
  fontFamily: 'Inter, Arial, sans-serif',
};

export const activeStatusSx: SxProps<Theme> = {
  ...statusChipBaseSx,
  backgroundColor: '#ECFDF5',
  color: '#064E3B',
  border: '1px solid #A7F3D0',
};

export const inactiveStatusSx: SxProps<Theme> = {
  ...statusChipBaseSx,
  backgroundColor: '#F3F4F6',
  color: '#374151',
  border: '1px solid rgba(0,0,0,0.06)',
};

export const mainColumnSx: SxProps<Theme> = { mt: 3, display: 'flex', flexDirection: 'column', gap: 2 };

export const detailsPaperSx: SxProps<Theme> = { width: '100%', maxWidth: '900px', alignSelf: 'flex-start', height: '335px', gap: 2, borderRadius: '14px', border: '1px solid rgba(0,0,0,0.06)', pt: '21px', pr: '21px', pb: '1px', pl: '21px' };
export const geofencePaperSx: SxProps<Theme> = { width: '100%', maxWidth: '900px', alignSelf: 'flex-start', height: '550px', gap: 2, borderRadius: '14px', border: '1px solid rgba(0,0,0,0.06)', p: '21px' };
export const staffingPaperSx: SxProps<Theme> = { width: '100%', maxWidth: '900px', alignSelf: 'flex-start', height: '146px', gap: 2, borderRadius: '14px', border: '1px solid rgba(0,0,0,0.06)', pt: '21px', pr: '21px', pb: '1px', pl: '21px' };
export const statusPaperSx: SxProps<Theme> = { width: '100%', maxWidth: '900px', alignSelf: 'flex-start', height: '166px', gap: 2, borderRadius: '14px', border: '1px solid rgba(0,0,0,0.06)', pt: '21px', pr: '21px', pb: '1px', pl: '21px' };

export const detailsContentSx: SxProps<Theme> = { display: 'flex', flexDirection: 'column', gap: 2 };
export const inputWrapperSx: SxProps<Theme> = { width: '100%', maxWidth: '858px', alignSelf: 'flex-start' };
export const labelSx: SxProps<Theme> = { fontSize: '13px', mb: 0.5 };

export const inputFieldSx: SxProps<Theme> = { '& .MuiInputBase-root': { height: '41.5px', borderRadius: '10px', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '12px', paddingRight: '12px' } };
export const addressFieldSx: SxProps<Theme> = { '& .MuiInputBase-root': { height: '61px', borderRadius: '10px', paddingTop: '30px', paddingBottom: '10px', paddingLeft: '12px', paddingRight: '12px' } };
export const selectSx: SxProps<Theme> = { height: '36px', borderRadius: '10px', '& .MuiSelect-select': { paddingTop: '11px', paddingBottom: '11px', paddingLeft: '10px', paddingRight: '10px' } };

export const searchBoxSx: SxProps<Theme> = { width: '100%', maxWidth: '356px', alignSelf: 'flex-start' };
export const searchFieldSx: SxProps<Theme> = { '& .MuiInputBase-root': { height: '38px', borderRadius: '10px', paddingTop: '8px', paddingBottom: '8px', paddingLeft: '36px', paddingRight: '12px' } };

export const mapPlaceholderSx: SxProps<Theme> = { width: '100%', maxWidth: '858px', alignSelf: 'flex-start', height: '240px', borderRadius: '14px', backgroundColor: '#F0F9F9', position: 'relative' };
export const repositionWrapperSx: SxProps<Theme> = { position: 'absolute', left: '700.5px', top: '9px' };
export const repositionButtonSx: SxProps<Theme> = {
  width: '123.1328125px',
  height: '25px',
  minWidth: '123.1328125px',
  padding: 0,
  textTransform: 'none',
  borderRadius: '10px',
  backgroundColor: 'rgba(255,255,255,0.9)',
  color: '#000',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '10px',
  lineHeight: '15px',
  letterSpacing: '0.12px',
  border: '1px solid #E5E7EB',
  boxShadow: 'none',
  '&:hover': { backgroundColor: 'rgba(255,255,255,0.95)', boxShadow: 'none' }
};

export const coordsBadgeSx: SxProps<Theme> = { position: 'absolute', left: 12, bottom: 12, backgroundColor: '#FFFFFF', px: 1, py: 0.5, borderRadius: '6px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' };

export const radiusContainerSx: SxProps<Theme> = { width: '100%', maxWidth: '858px', alignSelf: 'flex-start', display: 'flex', flexDirection: 'column', gap: '6px' };
export const sliderWrapperSx: SxProps<Theme> = { flex: 1 };
export const radiusValueSx: SxProps<Theme> = { mt: 1, display: 'flex', justifyContent: 'flex-end', width: '100%', maxWidth: '858px', alignSelf: 'flex-start' };

export const staffingInputSx: SxProps<Theme> = { width: '128px', '& .MuiInputBase-root': { height: '41.5px', borderRadius: '10px', paddingTop: '10px', paddingBottom: '10px', paddingLeft: '12px', paddingRight: '12px' } };

export const actionRowSx: SxProps<Theme> = { width: '100%', maxWidth: '900px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'flex-start' };

// Right group to contain Save / Cancel buttons
export const actionRightSx: SxProps<Theme> = { display: 'flex', gap: 2, alignItems: 'center' };

export const saveButtonSx: SxProps<Theme> = {
  width: '67px',
  height: '36px',
  borderRadius: '10px',
  paddingTop: '8px',
  paddingRight: '12px',
  paddingBottom: '8px',
  paddingLeft: '12px',
  backgroundColor: '#39A9B1',
  color: '#FFFFFF',
  textTransform: 'none',
};

export const cancelButtonSx: SxProps<Theme> = {
  width: '67px',
  height: '36px',
  borderRadius: '10px',
  borderWidth: '1px',
  paddingTop: '8px',
  paddingRight: '12px',
  paddingBottom: '8px',
  paddingLeft: '12px',
  backgroundColor: '#E5E7EB',
  color: '#111827',
  textTransform: 'none',
  border: '1px solid rgba(0,0,0,0.08)',
};

export const deactivateButtonSx: SxProps<Theme> = {
  width: '125px',
  height: '36px',
  gap: '8px',
  opacity: 1,
  borderRadius: '10px',
  borderWidth: '1px',
  paddingTop: '8px',
  paddingRight: '12px',
  paddingBottom: '8px',
  paddingLeft: '12px',
  textTransform: 'none',
  border: '1px solid #FCA5A5',
  backgroundColor: 'transparent',
  color: '#DE606C',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '&:hover': { backgroundColor: 'rgba(0,0,0,0.03)' }
};

// Deactivate confirmation modal styles
export const modalContainerSx: SxProps<Theme> = {
  position: 'absolute',
  width: '400px',
  height: '229.6953125px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '16px',
  backgroundColor: '#FFFFFF',
  opacity: 1,
  boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
};

export const modalHeaderSx: SxProps<Theme> = {
  width: '100%',
  height: '65px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid rgba(0,0,0,0.06)',
  px: '24px',
};

export const modalTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '-0.31px',
};

export const modalCloseIconSx: SxProps<Theme> = {
  width: '16px',
  height: '16px',
  minWidth: '16px',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'text.secondary',
  opacity: 1,
};

export const modalContentSx: SxProps<Theme> = {
  width: '100%',
  height: '164.6953125px',
  gap: '20px',
  px: '24px',
  pt: '20px',
  pb: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const modalWarningRowSx: SxProps<Theme> = {
  width: '352px',
  height: '67.1953125px',
  display: 'flex',
  gap: '12px',
  alignItems: 'flex-start',
};

export const modalBodyTextSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '22.4px',
  letterSpacing: '-0.15px',
  color: 'text.primary',
};

export const modalCancelButtonSx: SxProps<Theme> = {
  width: '76.4921875px',
  height: '37.5px',
  borderRadius: '10px',
  backgroundColor: '#E5E7EB',
  color: '#111827',
  textTransform: 'none',
  border: '1px solid rgba(0,0,0,0.08)',
};

export const modalDeactivateButtonSx: SxProps<Theme> = {
  width: '98.21875px',
  height: '35.5px',
  borderRadius: '10px',
  paddingTop: '8px',
  paddingRight: '16px',
  paddingBottom: '8px',
  paddingLeft: '16px',
  backgroundColor: '#DE606C',
  color: '#FFFFFF',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export default {};
